import { Achievement } from '@/models/reward';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsAchievementItem',
})
export default class CmgRewardsAchievementItem extends Vue {
  @Prop({ required: true, type: Object })
  achievement!: Achievement;

  onClickAchievementItem() {
    this.$services.ui.setModalVisibility('achievedBadge', true, { achievement: this.achievement });
  }
}
